import React from 'react'
import styled from 'styled-components'
import Close from '../icons/Close'

const Button = styled.button`
  height: 33px;
  cursor: pointer;
  opacity: 1;
  top: 6px;
  right: 16px;
  background-color: ${props => (props.color ? props.color : 'white')};
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  &:active {
    opacity: 0.7;
  }
`

export default function BtnClose({
  action,
  width,
  height,
  color,
  ...props
}) {
  return (
    <Button
      className="pr-0 border-0 position-absolute "
      onClick={action}
      color={color}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <Close width={width} height={height} />
    </Button>
  )
}
